import script from "./navigationFooterLower.vue?vue&type=script&setup=true&lang=js"
export * from "./navigationFooterLower.vue?vue&type=script&setup=true&lang=js"

import "./navigationFooterLower.vue?vue&type=style&index=0&id=5d2c0009&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d2c0009"]])

export default __exports__